// extracted by mini-css-extract-plugin
module.exports = {"presenterMenuOptionsHolder":"PresenterMenu_presenterMenuOptionsHolder__3ssFN","scrollContainer":"PresenterMenu_scrollContainer__2V3U5"};